"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const CardRenderItemComponent_vue_1 = __importDefault(require("@/client/components/card/CardRenderItemComponent.vue"));
const CardRenderSymbolComponent_vue_1 = __importDefault(require("@/client/components/card/CardRenderSymbolComponent.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'CardProductionBoxComponent',
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    components: {
        CardRenderItemComponent: CardRenderItemComponent_vue_1.default,
        CardRenderSymbolComponent: CardRenderSymbolComponent_vue_1.default,
    },
    methods: {
        getClasses() {
            const classes = ['card-production-box'];
            return classes.join(' ');
        },
    },
});
